import React, { useState, useEffect } from 'react';
import { useAuth } from '../../Context/auth';
import Swal from 'sweetalert2';
import './SystemLogs.css';
import MenuLateral from '../../Components/MenuPrincipal/MenuLateral';

const SystemLogsAdmin = () => {
    const { currentUser } = useAuth(); // user pode ser null dependendo do contexto, currentUser é o do firebase
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tenants, setTenants] = useState([]);

    // Filtros
    const [filters, setFilters] = useState({
        startDate: new Date().toISOString().split('T')[0], // Hoje
        endDate: new Date().toISOString().split('T')[0],   // Hoje
        level: '',
        search: '',
        selectedTenantId: 'all' // Admin vê todos por padrão
    });

    // Paginação
    const [page, setPage] = useState(1);
    const limit = 50;

    const fetchTenants = React.useCallback(async () => {
        try {
            const token = await currentUser.getIdToken(); // Obtem token atualizado
            const response = await fetch('/api/gerencial/clientes', {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            if (response.ok) {
                const data = await response.json();
                setTenants(data);
            }
        } catch (error) {
            console.error("Erro ao buscar tenants", error);
        }
    }, [currentUser]);

    const fetchLogs = React.useCallback(async () => {
        setLoading(true);
        try {
            const token = await currentUser.getIdToken(); // Obtem token atualizado
            const queryParams = new URLSearchParams({
                page,
                limit,
                startDate: filters.startDate,
                endDate: filters.endDate,
                level: filters.level,
                search: filters.search,
                selectedTenantId: filters.selectedTenantId
            }).toString();

            const response = await fetch(`/api/logs?${queryParams}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (response.ok) {
                const data = await response.json();
                setLogs(data);
            } else {
                const err = await response.json();
                Swal.fire('Erro', err.error || 'Erro ao buscar logs', 'error');
            }
        } catch (error) {
            console.error("Erro ao buscar logs", error);
            Swal.fire('Erro', 'Erro de conexão', 'error');
        } finally {
            setLoading(false);
        }
    }, [currentUser, page, limit, filters]);

    useEffect(() => {
        if (currentUser) { // Só busca se tiver user
            fetchTenants();
            fetchLogs();
        }
    }, [currentUser, fetchTenants, fetchLogs]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
        setPage(1); // Reset paginação ao filtrar
    };

    const showDetails = (log) => {
        Swal.fire({
            title: 'Detalhes do Log',
            html: `<pre style="text-align: left; max-height: 400px; overflow: auto; background: #f4f4f4; padding: 10px; border-radius: 5px;">${JSON.stringify(log.meta_data, null, 2)}</pre>`,
            width: '800px'
        });
    };

    return (
        <div style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar" style={{ width: '100%' }}>
                <div className="logs-header">
                    <h1 className="logs-title">Logs do Sistema (Admin)</h1>
                </div>
                <div className="container-fluid" style={{ maxWidth: '98%', padding: '0 2rem' }}>

                    {/* Filtros */}
                    <div className="card mb-4">
                        <div className="card-body">
                            <div className="row g-3">
                                <div className="col-md-3">
                                    <label className="form-label">Data Início</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="startDate"
                                        value={filters.startDate}
                                        onChange={handleFilterChange}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Data Fim</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="endDate"
                                        value={filters.endDate}
                                        onChange={handleFilterChange}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Nível</label>
                                    <select className="form-select" name="level" value={filters.level} onChange={handleFilterChange}>
                                        <option value="">Todos</option>
                                        <option value="info">Info</option>
                                        <option value="warn">Aviso</option>
                                        <option value="error">Erro</option>
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Tenant</label>
                                    <select className="form-select" name="selectedTenantId" value={filters.selectedTenantId} onChange={handleFilterChange}>
                                        <option value="all">Todos os Clientes</option>
                                        {tenants.map(t => (
                                            <option key={t.id} value={t.id}>{t.nome}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Buscar por mensagem, ação ou usuário..."
                                        name="search"
                                        value={filters.search}
                                        onChange={handleFilterChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Tabela */}
                    <div className="table-responsive bg-white shadow-sm p-3 rounded">
                        <table className="table table-hover align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th>Data/Hora</th>
                                    <th>Nível</th>
                                    <th>Tenant</th>
                                    <th>Usuário</th>
                                    <th>Ação</th>
                                    <th>Mensagem</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr><td colSpan="7" className="text-center py-4">Carregando...</td></tr>
                                ) : logs.length === 0 ? (
                                    <tr><td colSpan="7" className="text-center py-4">Nenhum log encontrado.</td></tr>
                                ) : (
                                    logs.map(log => (
                                        <tr key={log.id} className={log.level === 'error' ? 'table-danger' : log.level === 'warn' ? 'table-warning' : ''}>
                                            <td>{new Date(log.created_at).toLocaleString()}</td>
                                            <td>
                                                <span className={`badge ${log.level === 'error' ? 'bg-danger' : log.level === 'warn' ? 'bg-warning text-dark' : 'bg-info text-dark'}`}>
                                                    {log.level.toUpperCase()}
                                                </span>
                                            </td>
                                            <td>{log.tenant_nome || '-'}</td>
                                            <td>{log.user_nome || 'Sistema/Anônimo'}</td>
                                            <td>{log.action}</td>
                                            <td className="text-truncate" style={{ maxWidth: '300px' }} title={log.message}>{log.message}</td>
                                            <td>
                                                <button className="btn btn-sm btn-outline-primary" onClick={() => showDetails(log)}>
                                                    <i className="fa-solid fa-eye"></i> Detalhes
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Paginação Simples */}
                    <div className="d-flex justify-content-between mt-3">
                        <button className="btn btn-secondary" disabled={page === 1} onClick={() => setPage(page - 1)}>Anterior</button>
                        <span>Página {page}</span>
                        <button className="btn btn-secondary" onClick={() => setPage(page + 1)}>Próxima</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SystemLogsAdmin;
